import { useContext } from "react";
import PropTypes from "prop-types";
import AppContext from "AppContext";
import { formatCurrency } from "utils/currency";
import currencies from "utils/static/currencies";

const Money = ({ amount }) => {
    const { configurations } = useContext(AppContext);
    const currencyConfig = configurations.find((config) => config.id === "general_currency");
    const currency = currencies.find((c) => c.isoCode === currencyConfig?.value);
    return formatCurrency(amount, currency?.locale, currency?.isoCode);
};

Money.propTypes = {
    amount: PropTypes.number,
};

Money.defaultProps = {
    amount: 0,
};

export default Money;
